/*
 * De iconen uit legacy/current, één op één overgenomen. Ze zijn allemaal
 * decoratief: de betekenis staat altijd in de tekst ernaast, dus ze krijgen
 * aria-hidden en geen titel. De afmetingen komen uit site.css, niet uit het
 * SVG-element zelf — precies zoals in het origineel.
 */

const gedeeld = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  'aria-hidden': true,
} as const

export function IconMenu({ open = false }: { open?: boolean }) {
  return (
    <svg {...gedeeld} strokeWidth={2} strokeLinecap="round">
      {open ? (
        <path d="M6 6l12 12M18 6 6 18" />
      ) : (
        <path d="M3 6h18M3 12h18M3 18h18" />
      )}
    </svg>
  )
}

export function IconPijl() {
  return (
    <svg
      {...gedeeld}
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  )
}

export function IconKlok() {
  return (
    <svg
      {...gedeeld}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  )
}

export function IconPersoon() {
  return (
    <svg
      {...gedeeld}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  )
}

export function IconSchildVink() {
  return (
    <svg
      {...gedeeld}
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <path d="m9 11 3 3L22 4" />
    </svg>
  )
}

export function IconChevron() {
  return (
    <svg
      {...gedeeld}
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  )
}

export function IconVink() {
  return (
    <svg
      {...gedeeld}
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m5 12 5 5L20 6" />
    </svg>
  )
}

/** Het lijstitem met het ronde vinkje, zoals `.crit__list li` in site.css. */
export function VinkItem({ children }: { children: React.ReactNode }) {
  return (
    <li>
      <span className="ck" aria-hidden="true">
        <IconVink />
      </span>
      <span>{children}</span>
    </li>
  )
}
